import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useDeleteEiendom } from '../../hooks/useEiendom';
import { useTranslation } from '../../translations';
import { ValgtEiendomFormData } from '../eiendom/eiendomList';

export type BoligSalgValgFormData = {
    harBolig: ValgtWeb;
};

interface Props {
    soeknadId: string;
}

const BoligSalgValg: FC<Props> = ({ soeknadId }) => {
    const { boligSalg, button, validationMessage } = useTranslation();
    const {
        control,
        watch,
        setValue,
        formState: { errors },
        reset,
    } = useFormContext<BoligSalgValgFormData & ValgtEiendomFormData>();
    const { mutate: deleteEiendom } = useDeleteEiendom(soeknadId);
    const { eiendom } = watch();

    const onClickHarBolig = (data: ValgtWeb) => {
        if (data === ValgtWeb.NEI && eiendom) {
            if (eiendom && eiendom.uuid && eiendom.uuid.length > 0) {
                deleteEiendom(eiendom.uuid.toString());
            }
            reset();
            setValue('eiendom', undefined);
        }
        setValue('harBolig', data);
    };

    return (
        <Controller
            name="harBolig"
            control={control}
            rules={{
                validate: { ikkeValgtHarBolig: (value: ValgtWeb) => value !== ValgtWeb.IKKE_VALGT },
            }}
            render={({ field: { value } }) => (
                <ButtonToggles
                    label={boligSalg.togglesSelgeBolig}
                    data-track-id="kreditt-boliglaan-bolig-valg-selge-bolig"
                    data-track-linkname={value}
                    onChange={(value) => onClickHarBolig(value as ValgtWeb)}
                    selectedOption={value}
                    options={[
                        { label: button.ja, value: ValgtWeb.JA },
                        { label: button.nei, value: ValgtWeb.NEI },
                    ]}
                    errorMessage={
                        errors.harBolig?.type === 'ikkeValgtHarBolig' ? `${validationMessage.requiredChoose}` : ''
                    }
                />
            )}
        />
    );
};

export default BoligSalgValg;
